import { render, staticRenderFns } from "./EditPermit.vue?vue&type=template&id=657ef931"
import script from "./EditPermit.vue?vue&type=script&lang=js"
export * from "./EditPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports